import { render, staticRenderFns } from "./BillingExtraHandlingIndex.vue?vue&type=template&id=0bf40743&scoped=true&"
import script from "./BillingExtraHandlingIndex.vue?vue&type=script&lang=js&"
export * from "./BillingExtraHandlingIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingExtraHandlingIndex.vue?vue&type=style&index=0&id=0bf40743&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf40743",
  null
  
)

export default component.exports